// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error[data-v-01f0d9bc]{text-align:center;margin-top:2rem}", ""]);
// Exports
module.exports = exports;
